import React, { TextareaHTMLAttributes, forwardRef } from 'react';
import styles from './TextArea.module.scss';

type TextAreaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>((props, ref) => {
  return <textarea className={styles.textArea} ref={ref} {...props} />;
});

TextArea.displayName = 'TextArea';

export default TextArea;
